import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface Attachment {
  fileNameUrl: string
  title: string
  createdAt: Date
}

const getAttachmentsApi = (expenseId: string): Promise<any> => {
  return adminHttpClient.get(`/EEDashboard/GetReimbursed/Expense/${expenseId}/GetExpenseAttachments`)
}

export default getAttachmentsApi
